import { SYSTEM_CONFIG } from "./constants/system-config";

declare let __webpack_public_path__: string;
if (SYSTEM_CONFIG.frontEndBaseUrl && process.env.NODE_ENV !== "development") {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  __webpack_public_path__ = SYSTEM_CONFIG.frontEndBaseUrl;
}
